import { cx } from '@emotion/css';
import { Button, CheckboxV2, PrimaryColors, typographyStyle, Flex } from '@revenuemarket/cds';
import { Typography } from 'antd';
import { CheckboxValueType } from 'antd/es/checkbox/Group';

import { css } from '~libs/emotion';
import { PolicyModel } from '~models/policy';

interface Props {
  value?: CheckboxValueType[];
  onChange?: (value: CheckboxValueType[]) => void;
  agreements?: PolicyModel.Agreement[];
  size?: 'large';
  className?: string;
}

const AgreementsCheckboxGroup = ({ value, onChange, agreements, className, size }: Props) => {
  const handleCheckboxChange = (agreementId: number, checked: boolean) => {
    if (!onChange) return;

    const newValue = checked
      ? [...(value || []), agreementId]
      : (value || []).filter((id) => id !== agreementId);

    onChange(newValue);
  };

  return (
    <div
      className={cx(
        css`
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 8px;
        `,
        className,
      )}
    >
      {agreements?.map((agreement) => (
        <CheckboxV2
          key={agreement.id}
          checked={(value || []).includes(agreement.id)}
          disabled={agreement.disabled}
          onChange={(e) => handleCheckboxChange(agreement.id, e.target.checked)}
          checkboxSize={size === 'large' ? 'large' : 'medium'}
          showLabel={true}
          labelStyle={{
            width: '100%',
          }}
          label={
            <Flex
              justify="space-between"
              align="center"
              className={css`
                width: 100%;
              `}
            >
              <Typography.Text
                style={{
                  ...typographyStyle['16_400'],
                }}
              >{`[${agreement.required ? '필수' : '선택'}] ${agreement.title}`}</Typography.Text>
              <Button
                buttonSize="small"
                buttonType="transparent"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  window.open(agreement.url, '_blank', 'width=1080,height=800');
                }}
                className={css`
                  color: ${PrimaryColors.primary600};
                  font-size: 13px;
                  & > div {
                    width: max-content !important;
                  }
                `}
              >
                보기
              </Button>
            </Flex>
          }
        />
      ))}
    </div>
  );
};

export default AgreementsCheckboxGroup;
